import axios from "axios";
import axiosInstance from "../Hooks/axoisInstance";

export const apiCall = async ({
  url,
  method = "get",
  data = {},
  params = {},
  token = null,
}) => {
  try {
    const config = {
      url,
      method,
      params,
      data,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    console.error("API call error:", error);
    throw error;
  }
};



// import axios from "axios";

// // In-memory cache
// const cache = {};
// const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds

// // Helper function to generate a cache key
// const generateCacheKey = ({ url, method, params, data, token }) => {
//   const paramsString = JSON.stringify(params, Object.keys(params).sort());
//   const dataString = JSON.stringify(data, Object.keys(data).sort());
//   return `${method.toUpperCase()}:${url}:${paramsString}:${dataString}:${token}`;
// };

// // Helper function to check if cache is valid
// const isCacheValid = (cacheEntry) => {
//   if (!cacheEntry) return false;
//   const { timestamp } = cacheEntry;
//   return Date.now() - timestamp < CACHE_DURATION;
// };

// export const apiCall = async ({
//   url,
//   method = "get",
//   data = {},
//   params = {},
//   token = null,
// }) => {
//   // Generate cache key
//   const cacheKey = generateCacheKey({ url, method, params, data, token });

//   // Check for valid cached response
//   if (cache[cacheKey] && isCacheValid(cache[cacheKey])) {
//     // console.log("Returning cached response for:", cacheKey);
//     return cache[cacheKey].data;
//   }

//   try {
//     const config = {
//       url,
//       method,
//       params,
//       data,
//       headers: {
//         "Content-Type": "multipart/form-data",
//         Authorization: `Bearer ${token}`,
//       },
//     };

//     const response = await axios(config);

//     // Store response in cache
//     cache[cacheKey] = {
//       data: response.data,
//       timestamp: Date.now(),
//     };

//     return response.data;
//   } catch (error) {
//     console.error("API call error:", error);
//     throw error;
//   }
// };